export default {
  // Product modal state
  showProductStatusModal: null,

  // Product row IDs
  singleProductDeleteRowId: null,
  singleProductImageUploadRowId: null,

  // Product list state
  productListActiveTab: "on_sale",

  // Product data
  productsData: null,

  // Loading states
  isLoading: {
    products: false,
    productInfo: false,
    productImages: false,
    productUpload: false,
    productTemplate: false,
  },

  // Error states
  errors: {
    products: null,
    productInfo: null,
    productImages: null,
    productUpload: null,
    productTemplate: null,
  },

  // Product update state
  isPriceAreaUpdate: false,
  activePopoverId: null,
  isPriceAreaStatus: null,
  isPriceAreaErrorMessage: null,

   subTabsByKey: {},
};
